Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  getPosition: function () {
    function getPosition(value, min, max) {
      return (value - min) / (max - min) * 100;
    }

    return getPosition;
  }(),
  getValue: function () {
    function getValue(pos, min, max) {
      var decimal = pos / 100;

      if (pos === 0) {
        return min;
      } else if (pos === 100) {
        return max;
      }

      return Math.round((max - min) * decimal + min);
    }

    return getValue;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./~/rheostat/lib/algorithms/linear.js
// module id = 2534
// module chunks = 0